<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['online_transactions'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <BalanceDetails />
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div>
                  <label>From</label><input class="form-control" v-model="date_from" type="date" />
                </div>
                <div class="mx-1">
                  <label>To</label><input class="form-control" v-model="date_to" type="date" />
                </div>
                <div class="mt-4">
                  <b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i> Filter</b-button>
                </div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">

                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner v-if="data_status == 'Fetching data...'" class="align-middle" type="grow"></b-spinner>
                    <span v-else class="mdi mdi-cancel fs-1"></span>
                    <div class="fw-bold fs-5">{{ data_status }}</div>
                  </div>
                </template>

                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(addedby)="data">
                  {{ data.item.addedby.name }}
                </template>

                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col mt-3 fw-bold">Total Amount: <span class="ms-2">{{ commas(TotalAmount) }}/=</span></div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View {{title}}</span>
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { onlineTransactionComputed, onlineTransactionMethods } from "@/state/helpers";
import BalanceDetails from "./balanceDetails";

export default {
  page: {
    title: "Online Transactions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    BalanceDetails,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      data_status: 'Fetching data...',
      fetched: false,
      title: "Online Transactions",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Online Transactions", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "transaction_id", label: "TID", visible: true },
        { key: "amount", label: "Amount", visible: true },
        { key: "contact", label: "Contacts", visible: true },
        { key: "addedby", label: "Added By", visible: true },
        { key: "added_on", label: "Added On", visible: true },
      ],
      id: "",
      telephone: "",
      name: "",
      nationality: "",
      gender: "",
      address: "",
      dateofbirth: "",
      nin: "",
      date_of_joining: "",
      sacco_member_id: "",
      savingpackage: "",
      nokname: "",
      nokcontact: "",
      username: "",
      email: "",
      loader: false,
      loader2: false,
      date_to: new Date().toLocaleDateString("fr-CA"),
      date_from: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...onlineTransactionComputed,
    List() {
      if (this.fetched) {
        return this.onlinetransactions.length;
      } else {
        return 0;
      }
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      if (this.fetched) {
        return this.onlinetransactions.map((d) => ({ ...d }));
      } else {
        return [];
      }
    },
    IsBusy() {
      let a = false;
      if (this.onlinetransactions.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    TotalAmount() {
      if (this.fetched) {
        return this.onlinetransactions.reduce((a, b) => a + b.amount, 0);
      } else {
        return 0;
      }
    },
  },

  async mounted() {
    await this.fetchOnlineTransactions();
    this.fetched = true;
    this.data_status = 'No Data Found'
    this.TotalRows = this.onlinetransactions.length;
  },
  methods: {
    ...onlineTransactionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    restore(id, name) {
      this.id = id
      this.name = name
      this.$bvModal.show('restore-applicant')
    },

    async restoreApplicant() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "restore_application";
      const response = await axios.post(url, formData);
      if (response.status == 200) {
        this.fetchApplicants();
        this.$bvModal.hide('restore-applicant')
        this.$toast.success(
          `Application for ${response.data.applicant}, Restored!`
        );
      }
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(
      id,
      name,
      gender,
      telephone,
      nationality,
      address,
      dateofbirth,
      nin,
      date_of_joining,
      sacco_member_id,
      savingpackage,
      nokname,
      nokcontact,
      email,
      username
    ) {
      this.id = id;
      this.name = name;
      this.gender = gender;
      this.telephone = telephone;
      this.nationality = nationality;
      this.address = address;
      this.dateofbirth = dateofbirth;
      this.nin = nin;
      this.date_of_joining = date_of_joining;
      this.sacco_member_id = sacco_member_id;
      this.savingpackage = savingpackage.id;
      this.nokname = nokname;
      this.nokcontact = nokcontact;
      this.email = email;
      this.username = username;
      this.$bvModal.show("edit-member");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("reject-applicant");
    },

    async editMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("nationality", this.nationality);
      formData.append("address", this.address);
      formData.append("dateofbirth", this.dateofbirth);
      formData.append("nin", this.nin);
      formData.append("date_of_joining", this.date_of_joining);
      formData.append("sacco_member_id", this.sacco_member_id);
      formData.append("nokname", this.nokname);
      formData.append("nokcontact", this.nokcontact);
      formData.append("savingpackage", this.savingpackage);
      formData.append("email", this.email);
      formData.append("username", this.username);
      let url = "/updatemember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMembers();
          this.$bvModal.hide("edit-member");
        }
      });
    },
    async removeMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/reject_application";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchApplicants();
          this.$bvModal.hide("reject-applicant");
          this.$toast.error(
            `Application for ${response.data.applicant}, Deleted!`
          );
        }
      });
    },
    FilterData() {
      this.filterMembers({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>
